import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

/**
 * Listens for a "force-refresh" broadcast on the Supabase Realtime channel.
 * When received, clears caches and reloads the page.
 */
export function useForceRefreshListener() {
  useEffect(() => {
    const channel = supabase
      .channel('global-force-refresh')
      .on('broadcast', { event: 'force-refresh' }, async () => {
        console.log('[ForceRefresh] Received force-refresh broadcast');
        try {
          // Unregister service workers
          if ('serviceWorker' in navigator) {
            const regs = await navigator.serviceWorker.getRegistrations();
            await Promise.all(regs.map(r => r.unregister()));
          }
          // Clear cache storage
          if ('caches' in window) {
            const keys = await caches.keys();
            await Promise.all(keys.map(k => caches.delete(k)));
          }
        } catch (e) {
          console.error('[ForceRefresh] Cleanup error:', e);
        }
        // Hard reload
        window.location.reload();
      })
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);
}
